import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStatementUnavailable = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M3.375 1.5H10.0039C10.269 1.50006 10.5235 1.60549 10.7109 1.79297L13.332 4.41406C13.5195 4.60155 13.6249 4.85596 13.625 5.12109V13.5C13.625 14.0523 13.1773 14.5 12.625 14.5H3.375C2.82272 14.5 2.375 14.0523 2.375 13.5V2.5C2.375 1.94772 2.82272 1.5 3.375 1.5Z",
		stroke: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8 9.5542C8.27614 9.5542 8.5 9.33034 8.5 9.0542V4.92529C8.49982 4.6493 8.27603 4.42529 8 4.42529C7.72397 4.42529 7.50018 4.6493 7.5 4.92529V9.0542C7.5 9.33034 7.72386 9.5542 8 9.5542ZM8 11.5747C8.27614 11.5747 8.5 11.3508 8.5 11.0747C8.49993 10.7986 8.2761 10.5747 8 10.5747C7.7239 10.5747 7.50007 10.7986 7.5 11.0747C7.5 11.3508 7.72386 11.5747 8 11.5747Z",
		fill: "currentColor"
	})]
});
export default SvgStatementUnavailable;
